"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const CategoryNavigation_1 = __importDefault(require("../CategoryNavigation"));
const ShopPage = ({ route }) => (react_1.default.createElement("section", { className: "znd-shop-page" },
    react_1.default.createElement(CategoryNavigation_1.default, { className: "znd-shop-page__category-navigation" }),
    (0, react_router_config_1.renderRoutes)(route?.routes)));
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ allowAnonymous: true, scope: AuthorizationScopes_1.default.SHOP_READ })(ShopPage));
